import { Banner, Box, Button, Heading, Text } from '@betterment/samba-react';

interface PackageStatusProps {
  error: string | null | undefined;
  signablePackage: {
    type: string;
    signed: boolean;
    forwardedToEmail?: string | null;
  };
}

const PackageStatus: React.FC<PackageStatusProps> = ({ error, signablePackage }) => {
  return (
    <>
      {signablePackage.type === 'plan_documents' && (
        <Box css={{ mb: 'space.400' }}>
          <Heading as="h1">Sign your 401(k) plan document</Heading>
          <Text as="p" css={{ mt: 'space.100' }}>
            Please review and sign your 401(k) plan document, which is required to launch your 401(k) plan.
          </Text>
          <Text as="p" css={{ mt: 'space.100' }}>
            Note: The plan document is different from the Master Services Agreement you signed before accessing the
            onboarding hub. If you have questions about your plan document, contact us.
          </Text>
        </Box>
      )}
      {signablePackage.signed && (
        <Banner variant="success" css={{ mb: 'space.400' }}>
          <Banner.Content>
            {signablePackage.type === 'plan_documents' && <Text as="p">The plan documents are signed.</Text>}
          </Banner.Content>
        </Banner>
      )}
      {!signablePackage.signed && signablePackage.forwardedToEmail && (
        <Banner variant="success" css={{ mb: 'space.400' }}>
          <Banner.Content>
            {signablePackage.type === 'plan_documents' && (
              <Text as="p">
                The DocuSign® link to the plan document was forwarded to {signablePackage.forwardedToEmail}.
              </Text>
            )}
          </Banner.Content>
        </Banner>
      )}
      {error && (
        <Banner variant="critical" css={{ mb: 'space.400' }}>
          <Banner.Content>
            <Text as="p">
              {error}
              {', '}
              <Button variant="textPrimary" onClick={() => window.location.reload()}>
                please try again
              </Button>
            </Text>
          </Banner.Content>
        </Banner>
      )}
    </>
  );
};

export default PackageStatus;
